import { render } from "./InstgramStoryreviewcom.vue?vue&type=template&id=8c5c54fe&scoped=true"
import script from "./InstgramStoryreviewcom.vue?vue&type=script&lang=js"
export * from "./InstgramStoryreviewcom.vue?vue&type=script&lang=js"

import "./InstgramStoryreviewcom.vue?vue&type=style&index=0&id=8c5c54fe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c5c54fe"]])

export default __exports__